export function getDefaultFilter() {
  return ['clientCell', 'fullName', 'phone', 'mobile', 'email', 'country', 'statusId', 'marginCall', 'lastNote', 'totalNotes', 'totalDocuments', 'account.balance']
}

export function getClientFields() {
  return [
    'id', 'clientCell',

    /*Details fields*/
    'firstName', 'lastName', 'fullName', 'phone', 'mobile', 'country', 'city', 'address', 'zip', 'lang', 'email', 'birthday', 'gender', 'companyClient',

    //Manager fields
    'orgId', 'businessUnitId', 'creationTime', 'interestTime', 'ftdOwnerId', 'ftdTime','ftdAmount','stdOwnerId', 'stdTime', 'statusId',

    //Affiliate fields
    'affiliateName', 'campaign', 'banner', 'tag','affiliateSource',

    //Representative fields
     'representativeUserId', 'retentionUserId', 'lastAssignationTime',

    //Company fields
    'companyNumber', 'activity', 'position', 'companyName',

    'comment', 'active', 'lastNote', 'totalNotes', 'totalDocuments', 'lastNoteTime', 'lastNoteText', 'marginCall', 'account.balance', 'account.credit', 'account.equity', 'hasAccounts','lastConnection',
    'monetary.totalDeposits', 'monetary.totalWithdrawals',
  ]
}
